module.exports = __webpack_public_path__ + "static/img/icon-eay-type-discount-0.daa688e3.png";